import { getters } from './getters';
import { actions } from './actions';
import { mutations } from './mutations';

const state = {
  meta: {
    count: 0,
    currentPage: 1,
  },
  walletMeta: {
    count: 0,
    currentPage: 1,
  },
  records: {},
  sortOrder: [],
  walletRecords: {},
  walletSortOrder: [],
  currentCompany: {},
  appliedFilters: [],
  associations: {
    contacts: [],
    relatedCompanies: [],
  },
  notes: {
    data: [],
    meta: {
      currentPage: 1,
      totalPages: 0,
      perPage: 10,
      totalCount: 0,
      hasMore: false,
    },
  },
  activityEvents: {
    data: [],
    meta: {
      currentPage: 1,
      totalPages: 0,
      totalCount: 0,
      hasMore: false,
    },
  },
  tasks: [],
  selectedCompanyIds: [],
  uiFlags: {
    isFetching: false,
    isFetchingWallet: false,
    isFetchingItem: false,
    isCreating: false,
    isUpdating: false,
    isDeleting: false,
    isImporting: false,
    isExporting: false,
    isBulkAssigning: false,
    isBulkUpdating: false,
  },
  profileUiFlags: {
    isFetchingProfile: false,
    isFetchingContacts: false,
    isFetchingRelatedCompanies: false,
    isFetchingNotes: false,
    isFetchingActivityEvents: false,
    isCreatingNote: false,
    isUpdatingNote: false,
    isDeletingNote: false,
    isFetchingTasks: false,
    isCreatingTask: false,
    isUpdatingTask: false,
    isAssociatingContact: false,
    isAssociatingCompany: false,
    isUpdatingRelatedCompany: false,
    isRemovingAssociation: false,
    fetchError: '',
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
